import { Category } from "./Category"
import { ServiceSession } from "./ServiceSesssion"
import { ServicePicture } from "./ServicePicture"
import { File } from "../types/File.type"
import { Seller } from "./Seller"
import { ServiceStatus } from "../enum/serviceStatus.enum"
import { ServiceOffice } from "./ServiceOffice"
import { ServiceEventType } from "../enum/serviceEventType.enum"

export interface ServiceMoreInformation {
	title?: string
	description?: string
	footer?: string
}

interface ContructorParams {
	id: string
	title: string
	title_en?: string
	title_ca?: string
	description?: string
	description_en?: string
	description_ca?: string
	hint?: string
	hint_en?: string
	hint_ca?: string
	price?: number
	typeService?: string
	picture?: string
	pictures?: ServicePicture[]
	seller?: Seller
	isOnline?: boolean
	isPresential?: boolean
	isFoundation?: boolean
	serviceClusters: Partial<Category>[]
	serviceContent?: { pictures: ServicePicture[] }[]
	weight: number
	serviceSessions: ServiceSession[]
	endorsedUser?: { id: string; name: string } | null
	countryId?: string
	highlighted?: boolean
	endorsedName?: string
	endorsedUserId?: string
	endorsedUsername?: string
	crossSelling?: boolean
	status: ServiceStatus
	askForInformation?: boolean
	offices?: ServiceOffice[]
	hasWaitlist: boolean
	moreInformation?: ServiceMoreInformation | null
	cancellationHours?: number | null
	isForSurvey?: boolean
	consecutiveReservations: boolean
	isTournament: boolean
	finishTournamentDate?: Date | null
	eventDateTime?: Date | null
	prizes?: string
	place?: string
	estimatedDuration?: number | null
	availableTournamentPlaces?: number | null
	googleMapsUrl?: string
	eventType?: ServiceEventType
	participants?: number | null
	endDateTime?: Date | null
}

export class SellerServiceDetail {
	public id: string
	public title: string
	public title_en?: string
	public title_ca?: string
	public description?: string
	public description_en?: string
	public description_ca?: string
	public hint?: string
	public hint_en?: string
	public hint_ca?: string
	public price?: number
	public typeService?: string
	public picture?: string & File
	public pictures?: ServicePicture[] & File
	public isFoundation?: boolean
	public isOnline?: boolean
	public isPresential?: boolean
	public serviceClusters: Partial<Category>[]
	public weight: number
	public serviceSessions: ServiceSession[]
	public serviceContent?: { pictures: ServicePicture[] }[]
	public seller?: Seller
	public countryId?: string
	public highlighted?: boolean
	public endorsedName?: string | null
	public endorsedUserId?: string | null
	public endorsedUsername?: string | null
	public crossSelling: boolean
	public status: ServiceStatus
	public askForInformation?: boolean
	public offices?: ServiceOffice[]
	public hasWaitlist: boolean
	public consecutiveReservations: boolean
	public moreInformation?: ServiceMoreInformation | null
	public cancellationHours?: number | null
	public isForSurvey?: boolean
	public eventDateTime?: Date | null
	public endDateTime?: Date | null
	public prizes?: string
	public place?: string
	public estimatedDuration?: number | null
	public isTournament: boolean
	public finishTournamentDate?: Date | null
	public availableTournamentPlaces?: number | null
	public participants?: number | null
	public googleMapsUrl?: string
	public eventType?: ServiceEventType

	constructor(params: ContructorParams) {
		this.id = params.id
		this.title = params.title
		this.title_en = params.title_en
		this.title_ca = params.title_ca
		this.description = params.description
		this.description_en = params.description_en
		this.description_ca = params.description_ca
		this.hint = params.hint
		this.hint_en = params.hint_en
		this.hint_ca = params.hint_ca
		this.price = params.price
		this.typeService = params.typeService
		this.picture = params.picture
		this.pictures = params.pictures
		this.seller = params.seller
		this.isFoundation = params.isFoundation
		this.isOnline = params.isOnline
		this.isPresential = params.isPresential
		this.serviceClusters = params.serviceClusters
		this.weight = params.weight
		this.serviceSessions = params.serviceSessions
		this.serviceContent = params.serviceContent
		this.seller = params.seller
		this.countryId = params.countryId
		this.highlighted = params.highlighted
		this.endorsedName = params.endorsedName
		this.endorsedUserId = params.endorsedUserId
		this.endorsedUsername = params.endorsedUsername
		this.crossSelling = params.crossSelling ?? false
		this.status = params.status
		this.askForInformation = params.askForInformation
		this.offices = params.offices
		this.hasWaitlist = params.hasWaitlist
		this.moreInformation = params.moreInformation
		this.cancellationHours = params.cancellationHours
		this.isForSurvey = params.isForSurvey
		this.consecutiveReservations = params.consecutiveReservations
		this.isTournament = params.isTournament
		this.finishTournamentDate = params.finishTournamentDate
		this.availableTournamentPlaces = params.availableTournamentPlaces
		this.participants = params.participants
		this.eventDateTime = params.eventDateTime
		this.endDateTime = params.endDateTime
		this.prizes = params.prizes
		this.place = params.place
		this.estimatedDuration = params.estimatedDuration
		this.googleMapsUrl = params.googleMapsUrl
		this.eventType = params.eventType
	}
}
